export default class MeigaranewsrecentlService_quick {
  getNewsInfo(code, offset_dt, first_inc, lastnews_dt) {
    return fetch("https://api.tradersr.com/api/meigaranewsrecentl_quick?code=" + code + "&offset_dt=" + offset_dt + "&first_inc=" + first_inc + "&lastnews_dt=" + lastnews_dt)
      .then(res => res.json());
  }
}